export default "/static/webpack/media/hardiness-nb.9fa9a6a1.png";